/* sv-collection.js — Collection page enhancements */

(function () {
  'use strict';

  // Filter products client-side by title match
  function applySearchFilter(query) {
    var grid = document.querySelector('ul#product-grid, ul.product-grid, #product-grid');
    if (!grid) return;
    var items = Array.from(grid.querySelectorAll('li.grid__item'));
    var q = (query || '').trim().toLowerCase();
    items.forEach(function (item) {
      if (!q) {
        item.dataset.svSearchHidden = '';
      } else {
        var titleEl = item.querySelector('.card__heading a, .card__heading, h3.card__heading');
        var title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
        item.dataset.svSearchHidden = (title.indexOf(q) === -1) ? 'true' : '';
      }
    });
    // Reset to page 1
    var params = new URLSearchParams(window.location.search);
    params.delete('sv_page');
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    history.replaceState(null, '', newUrl);
    applyShowLimit();
  }

  // Inject search bar above sort bar, offset to align with product column
  function injectCollectionSearch() {
    if (document.querySelector('.sv-collection-search')) return;
    var sortBar = document.querySelector('facet-filters-form.facets-vertical-sort, .facets-vertical-sort');
    if (!sortBar) return;

    // Mobile (<=749px, Dawn's own breakpoint for this drawer): the "sidebar" isn't a real
    // left column at this width - it's tucked into the Filter/sort drawer - so its offsetWidth
    // doesn't represent a column to align past. Omit the inline padding-left entirely here so
    // the div's own .page-width class supplies its normal side padding instead (an inline style,
    // even "0px", would override .page-width's padding and flush the bar against the screen
    // edges). Desktop/tablet behavior (a real side-by-side sidebar) is unchanged.
    var sidebar = document.querySelector('.facets-wrapper, aside.facets-wrapper');
    var isMobileSearch = window.innerWidth <= 749;
    var styleAttr = '';
    if (!isMobileSearch) {
      var sidebarWidth = sidebar ? (sidebar.offsetWidth + 20) + 'px' : '270px';
      styleAttr = ' style="padding-left:' + sidebarWidth + '"';
    }

    var currentQ = (new URLSearchParams(window.location.search)).get('q') || '';
    var searchHtml = '<div class="sv-collection-search page-width"' + styleAttr + '>'
      + '<form class="sv-collection-search__form">'
      + '<input type="text" value="' + currentQ.replace(/"/g, '&quot;') + '" placeholder="Search products" class="sv-collection-search__input" aria-label="Search products">'
      + '<button type="submit" class="sv-collection-search__btn" aria-label="Search">Search</button>'
      + '</form>'
      + '</div>';

    sortBar.insertAdjacentHTML('beforebegin', searchHtml);

    // Client-side filtering — no page navigation
    var form = document.querySelector('.sv-collection-search__form');
    var input = document.querySelector('.sv-collection-search__input');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applySearchFilter(input ? input.value : '');
      });
    }
    // Apply immediately if ?q= already in URL (e.g. back-nav)
    if (currentQ) {
      applySearchFilter(currentQ);
    }
  }

  // Inject "Get a Quote" button on each product card
  function injectQuoteButtons() {
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      if (card.querySelector('.sv-quote-btn')) return;
      var link = card.querySelector('a.full-unstyled-link, a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');

      var btn = document.createElement('a');
      btn.href = href;
      btn.className = 'sv-quote-btn';
      btn.textContent = 'Get a Quote';

      var cardInfo = card.querySelector('.card__information, .card-information');
      if (cardInfo) {
        cardInfo.appendChild(btn);
      } else {
        card.appendChild(btn);
      }
    });
  }

  // Build page URL preserving existing params
  function getPageUrl(page, limit) {
    var params = new URLSearchParams(window.location.search);
    params.set('limit', limit);
    if (page > 1) { params.set('sv_page', page); } else { params.delete('sv_page'); }
    return window.location.pathname + '?' + params.toString();
  }

  // Inject JS pagination below the product grid
  function buildJSPagination(total, limit, currentPage) {
    var old = document.querySelector('.sv-js-pagination');
    if (old) old.remove();
    var totalPages = Math.ceil(total / limit);
    if (totalPages <= 1) return;

    var html = '<nav class="sv-js-pagination" role="navigation" aria-label="Pagination">';
    if (currentPage > 1) html += '<a href="' + getPageUrl(currentPage - 1, limit) + '" class="sv-js-pagination__btn">&#8249;</a>';
    for (var i = 1; i <= totalPages; i++) {
      if (i === currentPage) {
        html += '<span class="sv-js-pagination__btn sv-js-pagination__btn--active">' + i + '</span>';
      } else {
        html += '<a href="' + getPageUrl(i, limit) + '" class="sv-js-pagination__btn">' + i + '</a>';
      }
    }
    if (currentPage < totalPages) html += '<a href="' + getPageUrl(currentPage + 1, limit) + '" class="sv-js-pagination__btn">&#8250;</a>';
    html += '</nav>';

    var gridContainer = document.querySelector('#ProductGridContainer, .product-grid-container');
    if (gridContainer) gridContainer.insertAdjacentHTML('beforeend', html);
  }

  // Apply show limit with pagination (respects search filter)
  function applyShowLimit() {
    var params = new URLSearchParams(window.location.search);
    var limit = parseInt(params.get('limit') || '12', 10);
    var page  = parseInt(params.get('sv_page') || '1', 10);
    var grid  = document.querySelector('ul#product-grid, ul.product-grid, #product-grid');
    if (!grid) return;

    var allItems = Array.from(grid.querySelectorAll('li.grid__item'));
    // Only paginate items not hidden by search filter
    var visibleItems = allItems.filter(function (item) {
      return item.dataset.svSearchHidden !== 'true';
    });

    var start = (page - 1) * limit;
    var end   = start + limit;

    allItems.forEach(function (item) {
      if (item.dataset.svSearchHidden === 'true') {
        item.style.display = 'none';
      }
    });

    visibleItems.forEach(function (item, index) {
      item.style.display = (index >= start && index < end) ? '' : 'none';
    });

    buildJSPagination(visibleItems.length, limit, page);
  }

  // Inject Show per page dropdown (12 / 24 / 48) next to product count
  function injectShowDropdown() {
    if (document.querySelector('.sv-show-dropdown')) return;
    var countEl = document.querySelector('.product-count-vertical, .product-count__text');
    if (!countEl) return;

    var params = new URLSearchParams(window.location.search);
    var current = params.get('limit') || '12';

    var html = '<div class="sv-show-dropdown">'
      + '<label class="sv-show-dropdown__label">Show</label>'
      + '<select class="sv-show-dropdown__select" id="sv-per-page">'
      + ['12','24','48'].map(function(n) {
          return '<option value="' + n + '"' + (current === n ? ' selected' : '') + '>' + n + '</option>';
        }).join('')
      + '</select>'
      + '</div>';

    var form = document.querySelector('#FacetSortForm, .facets-vertical-form');
    if (form) {
      form.insertAdjacentHTML('beforeend', html);
    } else {
      var wrapper = countEl.closest('.product-count-vertical') || countEl.parentElement;
      wrapper.insertAdjacentHTML('afterend', html);
    }

    document.getElementById('sv-per-page').addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('limit', this.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  }

  // Hide Availability filter from sidebar
  function hideAvailabilityFilter() {
    var details = document.querySelectorAll('details.facets__disclosure-vertical');
    details.forEach(function (el) {
      var label = el.querySelector('.facets__heading, .facets__summary-info span');
      if (label && label.textContent.trim().toLowerCase() === 'availability') {
        el.style.display = 'none';
      }
    });
    // Also hide by data-index attribute
    var availEl = document.querySelector('[data-index="filter.v.availability"]');
    if (availEl) {
      var parent = availEl.closest('details');
      if (parent) parent.style.display = 'none';
    }
  }

  // Inject Call button on product pages
  function injectProductCallButton() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.sv-call-btn')) return;
    var buyButtons = document.querySelector('.product-form__buttons, .product-form__submit');
    if (!buyButtons) return;

    var btn = document.createElement('a');
    btn.href = 'tel:18002821944';
    btn.className = 'sv-call-btn';
    btn.textContent = '📞 Call 1-800-282-1944';
    buyButtons.parentNode.insertBefore(btn, buyButtons.nextSibling);
  }

  // Offset sort bar to align with product column (not overlap sidebar)
  function alignSortBar() {
    var sidebar = document.querySelector('.facets-wrapper, aside.facets-wrapper');
    var sortForm = document.querySelector('#FacetSortForm, .facets-vertical-form');
    if (!sidebar || !sortForm) return;
    // Same mobile guard as injectCollectionSearch() above - no real sidebar column to
    // align past below 750px.
    if (window.innerWidth <= 749) { sortForm.style.paddingLeft = ''; return; }
    sortForm.style.paddingLeft = (sidebar.offsetWidth + 20) + 'px';
  }

  // Run on DOM ready
  function init() {
    injectCollectionSearch();
    injectShowDropdown();
    alignSortBar();
    applyShowLimit();
    injectQuoteButtons();
    hideAvailabilityFilter();
    injectProductCallButton();

    // Re-run after AJAX filter updates
    document.addEventListener('facets:updated', function () {
      setTimeout(function () {
        injectQuoteButtons();
        hideAvailabilityFilter();
        injectCollectionSearch();
      }, 200);
    });

    // MutationObserver on body for dynamically loaded content
    var observer = new MutationObserver(function () {
      injectQuoteButtons();
      injectCollectionSearch();
      hideAvailabilityFilter();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback: retry every 500ms for first 4 seconds
    var retries = 0;
    var retryInterval = setInterval(function () {
      injectQuoteButtons();
      hideAvailabilityFilter();
      injectCollectionSearch();
      if (++retries >= 8) clearInterval(retryInterval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
